<template>
  <div class="price-container">
    <span aria-hidden="true" class="price__currency">{{ currency }}</span>
    <span aria-hidden="true" class="price__int">{{ priceObj.int }}</span>
    <span aria-hidden="true" class="price__decimal" v-if="priceObj.decimal">{{ showDecimalPoint ? '.' : '' }}{{ priceObj.decimal }}</span>
  </div>
</template>

<script>
import { getCurrency, getCurrencySymbol } from '@/utils/currency';

export default {
  name: 'Inline-Price',
  props: {
    currency: {
      type: String,
      default: getCurrencySymbol(getCurrency()),
    },
    price: String,
    unit: String,
    showDecimalPoint: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    priceNum() {
      return this.price.replace(this.currency, '');
    },
    priceObj() {
      const [int, decimal] = this.priceNum.split('.');
      return {
        int,
        decimal,
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.price-container {
  display: inline-flex;
  align-items: flex-start;
  color: #00053D;
}

.price__currency {
  font-family: "Almaden Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: uppercase;
}

.price__int {
  font-family: "Happy Display";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}

.price__decimal {
  font-family: "Almaden Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
